import type {Emoji} from '@github-ui/markdown-editor'
import {queryFnFetch} from '@github-ui/react-core/future/query-fn-fetch'
import {useQuery} from '@github-ui/react-query'

export function useEmojisQuery(enabled: boolean) {
  return useQuery({
    queryKey: ['autocomplete-emojis-for-editor'],
    enabled,
    queryFn: () =>
      queryFnFetch<Record<string, [url: string, character: string]>>({
        queryDeps: {pathname: '/autocomplete/emojis_for_editor'},
      }),
    select: (data): Emoji[] => Object.entries(data).map(([name, [url, character]]) => ({name, character, url})),
  })
}
